<template>
  <button 
    class="theme-toggle" 
    @click="toggleTheme"
    :class="{ 'dark-mode': isDarkMode }"
    aria-label="Toggle theme"
  >
    <span class="theme-icon sun-icon">☀️</span>
    <span class="theme-icon moon-icon">🌙</span>
    <span class="theme-switch"></span>
  </button>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'ThemeToggle',
  computed: {
    ...mapState(['isDarkMode'])
  },
  methods: {
    ...mapMutations(['toggleDarkMode']),
    toggleTheme() {
      this.toggleDarkMode();
    }
  }
};
</script>

<style scoped>
.theme-toggle {
  position: relative;
  width: 60px;
  height: 30px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 2px solid #10ccd2;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  padding: 0 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.theme-toggle:hover {
  box-shadow: 0 4px 12px rgba(16, 204, 210, 0.3);
  transform: scale(1.05);
}

.theme-toggle.dark-mode {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  border-color: #38bdf8;
}

.theme-icon {
  font-size: 14px;
  transition: all 0.3s ease;
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
}

.sun-icon {
  left: 8px;
  opacity: 1;
  transform: translateY(-50%) scale(1);
  transition: all 0.3s ease;
}

.moon-icon {
  right: 8px;
  opacity: 0.5;
  transform: translateY(-50%) scale(0.8);
  transition: all 0.3s ease;
}

.theme-toggle.dark-mode .sun-icon {
  opacity: 0.5;
  transform: translateY(-50%) scale(0.8);
}

.theme-toggle.dark-mode .moon-icon {
  opacity: 1;
  transform: translateY(-50%) translateX(4px) scale(1);
}

.theme-switch {
  position: absolute;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  left: 5px;
}

.theme-toggle.dark-mode .theme-switch {
  left: 35px;
  background: #fbbf24;
}

@media screen and (max-width: 767px) {
  .theme-toggle {
    width: 50px;
    height: 25px;
    border-radius: 12.5px;
  }
  
  .theme-switch {
    width: 16px;
    height: 16px;
  }
  
  .theme-toggle.dark-mode .theme-switch {
    left: 29px;
  }
  
  .theme-icon {
    font-size: 12px;
  }
  
  .sun-icon {
    left: 6px;
  }
  
  .moon-icon {
    right: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ThemeToggle.vue